<template>
  <div class="modal-card" :class="{ 'align-middle': !showDocumentSidebar && !showModuleSidebar && !showTemplateSidebar }">
    <slot name="document-title"></slot>

    <loading-indicator v-if="documentLoaded === false"></loading-indicator>

    <document-part-cover :payload="payload" v-if="documentLoaded && payload.cover" @update="updateCover" state="editor"></document-part-cover>

    <div class="document" v-if="documentLoaded" :style="{ 'font-family': payload.options.documentFont }" :class="{ 'is-module': $route.path.indexOf('/module/') > -1 }">

      <draggable :list="payload.body" :options="{ group: 'omega',  handle: '.handle' }" @sort="flattenModules">
        <transition-group>
          <div v-for="(part, key) in payload.body" :key="part.id" class="document-item">
            <div class="columns">
              <div class="document-drag-zone">{{ $t('proposal_editor_modal.drop_content_here') }}</div>
              <div class="column is-1">
                <div class="handle">
                  <span class="handle-dot"><i class="icon icon-move"></i></span>
                </div>

                <span class="document-item-type" v-if="part.type === 'h1'">
                  <i class="icon icon-h1"></i>
                  <ul class="document-item-type-changer">
                    <li @click="convertPart(part, 'h2')"><i class="icon icon-h2"></i></li>
                    <li @click="convertPart(part, 'h3')"><i class="icon icon-h3"></i></li>
                    <li @click="convertPart(part, 'text')"><i class="icon icon-p"></i></li>
                  </ul>
                </span>
                <span class="document-item-type" v-if="part.type === 'h2'">
                  <i class="icon icon-h2"></i>
                  <ul class="document-item-type-changer">
                    <li @click="convertPart(part, 'h1')"><i class="icon icon-h1"></i></li>
                    <li @click="convertPart(part, 'h3')"><i class="icon icon-h3"></i></li>
                    <li @click="convertPart(part, 'text')"><i class="icon icon-p"></i></li>
                  </ul>
                </span>
                <span class="document-item-type" v-if="part.type === 'h3'">
                  <i class="icon icon-h3"></i>
                  <ul class="document-item-type-changer">
                    <li @click="convertPart(part, 'h1')"><i class="icon icon-h1"></i></li>
                    <li @click="convertPart(part, 'h2')"><i class="icon icon-h2"></i></li>
                    <li @click="convertPart(part, 'text')"><i class="icon icon-p"></i></li>
                  </ul>
                </span>
                <span class="document-item-type" v-if="part.type === 'bulleted-list'"><i class="icon icon-bulleted-list"></i></span>
                <span class="document-item-type" v-if="part.type === 'numbered-list'"><i class="icon icon-numbered-list"></i></span>
                <span class="document-item-type" v-if="part.type === 'image'"><i class="icon icon-image"></i></span>
                <span class="document-item-type" v-if="part.type === 'table'"><i class="icon icon-table"></i></span>
                <span class="document-item-type" v-if="part.type === 'pricing-table'"><i class="icon icon-pricing-table"></i></span>
                <span class="document-item-type" v-if="part.type === 'signatures'"><i class="icon icon-signature"></i></span>

              </div>
              <div class="column is-10">
                <div class="part-wrapper">
                  <document-part-h1 v-if="part.type === 'h1'" :part="part" @update="updateContent" state="editor"></document-part-h1>
                  <document-part-h2 v-if="part.type === 'h2'" :part="part" @update="updateContent" state="editor"></document-part-h2>
                  <document-part-h3 v-if="part.type === 'h3'" :part="part" @update="updateContent" state="editor"></document-part-h3>
                  <document-part-text v-if="part.type === 'text'" :part="part" @update="updateContent" state="editor"></document-part-text>
                  <document-part-bulleted-list v-if="part.type === 'bulleted-list'" :part="part" @update="updateContent" state="editor"></document-part-bulleted-list>
                  <document-part-numbered-list v-if="part.type === 'numbered-list'" :part="part" @update="updateContent" state="editor"></document-part-numbered-list>
                  <document-part-image v-if="part.type === 'image'" :part="part" @update="updateContent" state="editor"></document-part-image>
                  <document-part-table v-if="part.type === 'table'" :part="part" @update="updateContent" state="editor"></document-part-table>
                  <document-part-module v-if="part.type === 'module'" :part="part" @update="updateContent" state="editor"></document-part-module>
                  <document-part-pricing-table v-if="part.type === 'pricing-table'" :part="part" @update="updateContent" state="editor"></document-part-pricing-table>
                  <document-part-page-break v-if="part.type === 'page-break'" state="editor"></document-part-page-break>
                  <document-part-initials v-if="part.type === 'initials'" :signatures="payload.signatures" :part="part" state="editor"></document-part-initials>
                  <document-part-signatures v-if="part.type === 'signatures'" :signatures="payload.signatures" :part="part" state="editor"></document-part-signatures>
                </div>
              </div>

              <div class="options-wrapper">
                <router-link :to="'/a/document/' + payload.id + '/comments'" :class="{ 'is-hidden': $route.path.indexOf('/module/') > -1, 'is-hidden': $route.path.indexOf('/template/') > -1 }">
                  <span><i class="icon icon-new-comment"></i></span>
                </router-link>
                <span @click="deletePart(key)"><i class="icon icon-trash"></i></span>
              </div>

            </div>
          </div>
        </transition-group>
      </draggable>
    </div>
  </div>
</template>

<script>
  import draggable from 'vuedraggable';
  import DocumentPartCover from '../document-parts/cover.vue';
  import DocumentPartText from '../document-parts/text.vue';
  import DocumentPartH1 from '../document-parts/h1.vue';
  import DocumentPartH2 from '../document-parts/h2.vue';
  import DocumentPartH3 from '../document-parts/h3.vue';
  import DocumentPartBulletedList from '../document-parts/bulleted-list.vue';
  import DocumentPartNumberedList from '../document-parts/numbered-list.vue';
  import DocumentPartImage from '../document-parts/image.vue';
  import DocumentPartTable from '../document-parts/table.vue';
  import DocumentPartPageBreak from '../document-parts/page-break.vue';
  import DocumentPartPricingTable from '../document-parts/pricing-table.vue';
  import DocumentPartSignatures from '../document-parts/signatures.vue';

  export default {
    props: ['payload', 'documentLoaded', 'showDocumentSidebar', 'showModuleSidebar', 'showTemplateSidebar'],
    components: {
      draggable,
      DocumentPartCover,
      DocumentPartText,
      DocumentPartH1,
      DocumentPartH2,
      DocumentPartH3,
      DocumentPartBulletedList,
      DocumentPartNumberedList,
      DocumentPartImage,
      DocumentPartTable,
      DocumentPartPageBreak,
      DocumentPartPricingTable,
      DocumentPartSignatures,
    },
    mounted() {
      this.payload.options = this.payload.options || {};
    },
    methods: {
      deletePart(key) {
        this.payload.body.splice(key, 1)
      },
      updateCover(cover) {
        this.$set(this.payload, 'cover', cover);
      },
      updateContent(options) {
        let part = _.findWhere(this.payload.body, { id: options.part.id });

        if (part) {
          part.content = options.value;
        }
      },
      flattenModules() {
        this.$emit('update', _.flatten(this.payload.body));
      },
      convertPart(part, type) {
        part.type = type;
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "resources/assets/sass/layout/_variables";

  .document {
    min-height: min-content;
    * {
      font-family: inherit;
    }
  }

  .modal-card {
    position: relative;
    width: 100%;
    min-height: min-content;
    display: flex;
    background: none;
    margin-top: 0;
    margin-left: 0;
    margin-right: 300px;
    box-shadow: none;

    &.align-middle {
      margin-left: auto;
      margin-right: auto;

      form.document-title-wrapper {
        padding-right: 0;
      }
    }
    // Document name header
    form.document-title-wrapper {
      width: 100%;
      padding: 0;
      padding-right: 300px;
      position: fixed;
      top: 0;
      left: 0;
      height: 60px;
      background: darken($eggshell, 2%);
      z-index: 10;

      .label {
        display: flex;
        flex-direction: row;
        width: 800px;
        margin: 0 auto;
        padding: 20px 0;
        i {
          margin-right: 5px;
        }
        .page-header {
          display: flex;
          font-weight: 700;
          font-size: 16px;
          text-transform: uppercase;
          letter-spacing: 1px;
          color: $purple;
          padding: 0;
          &:hover {
            cursor: pointer;
          }
        }
        input {
          display: flex;
          flex-basis: 65%;
          font-size: 16px;
          border-bottom: none;
          margin-top: -3px;
          border: none;
          outline: none;
          position: relative;
          background: none;
          padding: 5px;
          &:focus {
            background: $white;
          }
        }

        .click-to-edit {
          font-size: 10px;
          text-transform: uppercase;
          letter-spacing: 1px;
          color: $mutedblue;
          position: absolute;
          left: 19%;
          top: 4px;
          display: none;
        }
        &:hover {
          .click-to-edit {
            display: block;
          }
          input {
            background: $white;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// document-editor-main.vue?535a8c5e